<script setup>
import {Head, usePage} from '@inertiajs/vue3';

import Header from '@/Components/Layout/Header.vue';
import Footer from '@/Components/Layout/Footer.vue';
import ProductConfigurator from '@/Components/Modals/ProductConfigurator.vue';
import {inject, onMounted} from 'vue';
import {useCartStore} from '@/stores/cart';
import Toasts from "@/Components/Toasts.vue";

defineProps({
    title: String,
    description: String,
    image: String,
    pageType: String,
});

const route = usePage().props.route;
if (typeof axios !== 'undefined') axios.defaults.headers.common['Accept-Language'] = usePage().props.locale;

const shoppingCart = useCartStore();

onMounted(() => {
    shoppingCart.load(usePage().props.shopping_cart, inject('route'));
})

</script>

<template>
    <Head>
        <title>{{ title }}</title>
        <meta
            :content="description"
            head-key="description"
            name="description"
        >
        <meta
            content="Jumbo Bas Bobeldjk"
            property="og:site_name"
        >
        <meta
            :content="title"
            property="og:title"
        >
        <meta
            :content="description"
            property="og:description"
        >
        <meta
            :content="image"
            property="og:image"
        >
        <meta
            :content="pageType ?? 'website'"
            property="og:type"
        >
        <meta
            :content="route.current"
            property="og:url"
        >
        <meta
            :content="$i18n.locale"
            property="og:locale"
        >

        <link
            :href="route.locale.nl"
            hreflang="nl"
            rel="alternate"
        >
        <link
            :href="route.locale.nl"
            hreflang="x-default"
            rel="alternate"
        >
        <link
            :href="route.current"
            rel="canonical"
        >
    </Head>


    <Header />

    <main class="mb-20 bg-grey">
        <slot />
    </main>

    <Footer />

    <ProductConfigurator v-if="shoppingCart.productConfigurator" />

    <Toasts />
</template>

<style>
body {
    background-color: #f5f2ef;
}
</style>
